import { render, staticRenderFns } from "./site-editor.vue?vue&type=template&id=54f1893a&"
import script from "./site-editor.vue?vue&type=script&lang=js&"
export * from "./site-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports